<template>
  <div>
    <div id="dropdown" />
    <div class="md:flex md:flex-col">
      <div class="md:flex md:flex-col md:h-screen">
        <div v-if="$page.component !== 'Orders/Pos'" class="md:flex md:flex-shrink-0">
          <div class="flex items-center justify-between bg-white border-b border-gray-100 md:flex-shrink-0 md:justify-center md:w-56">
            <Link class="mt-1 mb-1 px-4" href="/">
              <logo class="fill-white" width="120" height="50" />
            </Link>
            <dropdown class="md:hidden" placement="bottom-end">
              <template #default>
                <i class="fas fa-bars text-gray-500 text-xl p-4" />
              </template>
              <template #dropdown>
                <div class="mt-2 px-8 py-4 bg-gray-900 rounded-xl shadow-lg">
                  <main-menu v-if="auth?.user?.account" :account="auth.user.account" />
                </div>
              </template>
            </dropdown>
          </div>

          <div class="md:text-md flex items-center justify-between p-4 w-full text-sm bg-white border-b border-gray-100 md:px-12 md:py-0">
            <div class="mr-4 mt-1 text-[10px] font-bold text-gray-400 uppercase tracking-widest">
              Tasa: <span class="text-orange-600 font-black">1$ = {{ change || 1 }} Bs.</span>
            </div>
            <div class="font-black text-xl text-gray-900 tracking-tighter">
              {{ time }}
            </div>
            <dropdown class="mt-1" placement="bottom-end">
              <template #default>
                <div v-if="auth?.user" class="group flex items-center cursor-pointer select-none">
                  <div class="mr-1 text-gray-700 group-hover:text-orange-600 focus:text-orange-600 whitespace-nowrap transition-colors">
                    <span class="font-bold">{{ auth.user.first_name }}</span>
                    <span class="hidden md:inline">&nbsp;{{ auth.user.last_name }}</span>
                  </div>
                  <i class="fas fa-chevron-down text-xs text-gray-400 group-hover:text-orange-500 transition-colors" />
                </div>
              </template>
              <template #dropdown>
                <div v-if="auth?.user" class="mt-2 py-2 text-sm bg-white rounded-2xl shadow-2xl border border-gray-100 min-w-[200px] overflow-hidden">
                  <Link class="block px-6 py-3 hover:text-white hover:bg-orange-500 font-medium transition-colors" :href="`/users/${auth.user.id}/edit`">
                    <i class="fas fa-user-circle mr-3 opacity-50" /> Mi perfil
                  </Link>
                  <Link v-if="auth.user.role === 'admin'" class="block px-6 py-3 hover:text-white hover:bg-orange-500 font-medium transition-colors" href="/users">
                    <i class="fas fa-users-cog mr-3 opacity-50" /> Usuarios
                  </Link>
                  <div class="border-t border-gray-50 my-1" />
                  <Link class="block px-6 py-3 w-full text-left hover:text-white hover:bg-rose-500 text-rose-600 font-bold transition-colors" href="/logout" method="delete" as="button">
                    <i class="fas fa-sign-out-alt mr-3 opacity-50" /> Cerrar sesión
                  </Link>
                </div>
              </template>
            </dropdown>
          </div>
        </div>
        <div class="md:flex md:flex-grow md:overflow-hidden">
          <!-- <main-menu 
            v-if="$page.component !== 'Orders/Pos' && auth?.user?.account" 
            :account="auth.user.account"
            class="hidden flex-shrink-0 p-8 w-56 bg-white border-r border-gray-100 overflow-y-auto md:block" 
          /> -->
          <div class="md:flex-1 md:overflow-y-auto bg-gray-50/50" scroll-region>
            <flash-messages />
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'

export default {
  components: {
    Dropdown,
    FlashMessages,
    Icon,
    Link,
    Logo,
    MainMenu,
  },
  props: {
    auth: Object,
    change: Number,
  },
  data() {
    return {
      date: '',
      time: '',
    }
  },
  mounted() {
    const self = this
    self.time = self.update()
    setInterval(() => {
      self.time = self.update()
    }, 1000)
  },
  methods: {
    zeroPadding: (num, digit) => {
      var zero = ''
      for(var i = 0; i < digit; i++) {
        zero += '0'
      }
      return (zero + num).slice(-digit)
    },
    update: () => {
      let cd = new Date()
      let hours = ''
      let minutes = ''
      let secounds = ''
      let zero = ''

      for(let i = 0; i < 1; i++) {
        zero += '0'
      }
      hours = cd.getHours() > 9 ? cd.getHours() : (zero + cd.getHours())
      minutes =  cd.getMinutes() > 9 ? cd.getMinutes() : (zero + cd.getMinutes())
      secounds = cd.getSeconds() > 9 ? cd.getSeconds() :(zero + cd.getSeconds())

      return hours + ':' + minutes + ':' + secounds
    },
  },
}
</script>
